// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1lNKG","name":"Header_name__133My","birthday":"Header_birthday__1TbRa","skeleton":"Header_skeleton__1XRvw"};